import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { ProtectedRoute } from '@/features/auth';

export function AppLayout() {
  return (
    <ProtectedRoute>
      <div className="page">
        <Header />
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xl">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
}
